import store from '../reducers'
import events from 'actions/events'
import dayjs from 'lib/helpers/dayjs';
import { 
    TimeSlotActions, 
    SelectedTimeSlotActions, 
    PageActions, 
    PatientActions, 
    SelectedPatientActions,
    ConfigActions
} from 'actions'

export default () => {
    ConfigActions.append({
        placeholderAppointment: true,
        hideBackButton: true
    })
    
    events.on('Filters.componentDidSubmit',()=>{
        const administratorID = Object.keys(
            store.getState().administrators
        )[0]

        const appointmentType = store.getState().appointmentTypes[store.getState().filters.appointmentTypeID] || {}
        const startsAt = dayjs().format()
        const duration = JSON.parse(`[${appointmentType.durations}]`)[store.getState().filters.patientCount-1]
        const value = parseInt(duration || '60')
    
        const endsAt = dayjs().add(value, 'minutes').format()
        const selectedTimeslot = {
            id: `${administratorID}-${startsAt}-${endsAt}`,
            startsAt,
            endsAt,
            administratorID
        }

        TimeSlotActions.set({
            [`${administratorID}`]:{
                [`${selectedTimeslot.id}`]: selectedTimeslot
            }
        })
        SelectedTimeSlotActions.set(selectedTimeslot)

        let selectedPatientIDs = Object.keys(store.getState().selectedPatients)
        if(selectedPatientIDs.length != store.getState().filters.patientCount){
            let patients = {}
            for(let i = store.getState().filters.patientCount - selectedPatientIDs.length; i > 0; i--){
                patients[`newPatient-fill-${i}`] = {id: `newPatient-fill-${i}`, name: `Patient ${i}`}
            }
            PatientActions.set(patients)
            SelectedPatientActions.appendMany(patients)
        }

        PageActions.navToCollectInformation()
    })

    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })

    events.on('Confirmation.componentDidSubmit',()=>{
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/registration.js